import { Link } from "@tanstack/react-router";

import { CookieSettingsButton } from "#/components/CookieConsent";

const footerLinkClassName =
  "text-muted-foreground underline-offset-4 hover:text-foreground hover:underline";

function FooterLinkSeparator() {
  return (
    <span aria-hidden="true" className="text-muted-foreground/60">
      ·
    </span>
  );
}

function FooterLegalNav() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-1 gap-y-1 sm:flex-nowrap sm:justify-end">
      <Link to="/updates" className={footerLinkClassName}>
        Updates
      </Link>
      <FooterLinkSeparator />
      <Link to="/terms" className={footerLinkClassName}>
        Terms
      </Link>
      <FooterLinkSeparator />
      <Link to="/privacy-policy" className={footerLinkClassName}>
        Privacy
      </Link>
      <FooterLinkSeparator />
      <Link to="/cookie-policy" className={footerLinkClassName}>
        Cookies
      </Link>
      <FooterLinkSeparator />
      <CookieSettingsButton />
    </div>
  );
}

export { FooterLegalNav };
